import ResetPassword from '../../views/Master/ResetPassword'
import WithFormEvent from '../../components/WithFormEvent'
import { ajaxPost } from '../../global';


export default WithFormEvent(ResetPassword, {

  onSubmit: function (values, callback) {
    if (!values.Email) {
      alert("Email is required");
      return Promise.resolve({});
    }

    var url = 'ResetPassword';
    var data = { Email: values.Email };
    console.log("data: ", data)
    ajaxPost(url, data).then(response => {
      console.log("ResetPassword", response);
      if (response) {
        if (response.Error) {
          alert(response.Error)
        }
        else {
          alert('Password Reset Email Sent')
        }
      }
      // if (response.keyNo)
      //   values.RatingCode = response.keyNo;

      // if (callback)
      //   callback({
      //     values: values
      //   });
    });

  },

})



// WEBPACK FOOTER //
// ./src/containers/Master/ResetPassword.js